import { mdiVote } from "@mdi/js";
import Icon from "@mdi/react";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import ElectionInput from "../../../../common/electionsInputField/ElectionInput";
import { MessageContext } from "../../../../common/message";
import { ThemeContext } from "../../../../common/theme/ThemeContext";
import { GET, POST } from "../../../../utils/fetchUtil";

const AddNewVoters = () => {
  const theme = useContext(ThemeContext);
  const { t } = useTranslation();
  const message = useContext(MessageContext);
  const location = useLocation();
  const [evidencijskiBroj, setEvidencijskiBroj] = useState("");

  const typeName = location.state.typeName;
  const electionId = location.state.id;

  const handleEvidencijskiBrojInputChange = (e) => {
    const { name, value } = e.target;
    setEvidencijskiBroj(value);
  };

  // Centers placeholder text in this specific screen
  useEffect(() => {
    var inputs = document.querySelectorAll(".election-input-label");
    inputs.forEach((input) => {
      input.style.left = "45px";
    });
  }, []);

  const onClickHandler = () => {
    GET(
      "/userInfo?evidencijskiBroj=" + evidencijskiBroj,
      (userData) => {
        POST(
          "/addVoter",
          { electionId: electionId, voterId: userData.id },
          (response) => {
            let responseMsg = response.replace(
              "Korisnik",
              `Korisnik/ca ${userData.ime} ${userData.prezime}`
            );
            responseMsg = responseMsg.replace("Član", `Član ${userData.ime} ${userData.prezime}`);
            message.toggle({
              title: t("modalMessage.titleNotice"),
              content: responseMsg,
              hideNo: true,
              yesLabel: t("modalMessage.okLabel"),
              onYes: () => {
                message.toggle({});
              },
            });
            setEvidencijskiBroj("");
          },
          (error) => {
            message.toggle({
              title: t("requests.reviewDocuments.action.save.error"),
              content: error,
              hideNo: true,
              yesLabel: t("modalMessage.okLabel"),
              onYes: () => {
                message.toggle({});
              },
            });
          }
        );
      },
      (error) => {
        message.toggle({
          title: t("requests.reviewDocuments.action.save.error"),
          content: error,
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
          },
        });
      }
    );
  };

  return (
    <>
      <div className="is-flex is-align-items-center is-justify-content-center mt-6">
        <h1 className="m-0 mr-3 is-size-3">Elektronički</h1>
        <Icon path={mdiVote} size={2.2} className={`has-text-${theme.iconColor}`} />
        <h1 className="m-0 ml-3 is-size-3"> izbori</h1>
      </div>
      <div className="columns is-mobile mt-6">
        <div className="column is-three-fifths is-offset-one-fifth">
          <div className="is-size-3 has-text-centered">{typeName}</div>
        </div>
      </div>
      <div className="columns is-mobile mt-6">
        <div className="column is-three-fifths is-offset-one-fifth">
          <div className="is-size-4 is-italic has-text-centered mt-6">
            Pridružite članove koji u vrijeme prijave izbora nisu bili migrirani, ali su na dan
            raspisivanja izbora imali licencu u statusu "Ima odobrenje za rad"
          </div>
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }} className="columns is-mobile mt-6">
        <div style={{ width: "350px" }} className="has-text-centered mt-6">
          <ElectionInput
            isRequired={false}
            placeholder="Unesi evidencijski broj"
            value={evidencijskiBroj}
            onChange={handleEvidencijskiBrojInputChange}
          />
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }} className="columns is-mobile mt-6">
        <div>
          <div className="has-text-centered mt-4">
            <button className="button" onClick={onClickHandler}>
              Pridruži člana
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddNewVoters;
